var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsInt, Matches, Max, Min } from 'class-validator';
/**
 * Body for `POST /offices/:officeId/datev-export`.
 *
 * `yearMonth` is the calendar month to export, encoded as `"YYYY-MM"`. The
 * backend resolves it against the OfficeLocation's fiscal-year window and
 * the candidate reader's selected `exportMode` (issue date for Bilanz,
 * payment date for EÜR).
 */
export class GenerateDatevExportDto {
    /** `"YYYY-MM"` — calendar month for which to export. */
    yearMonth;
}
__decorate([
    Matches(/^\d{4}-(0[1-9]|1[0-2])$/, { message: 'yearMonth must be "YYYY-MM"' }),
    __metadata("design:type", String)
], GenerateDatevExportDto.prototype, "yearMonth", void 0);
/**
 * Year-month parsed/typed shape — convenience for handlers. The serialised
 * wire format is the string. Year is bounded loosely to catch obvious typos
 * (DATEV importer only accepts 1990-2099 anyway).
 */
export class YearMonth {
    year;
    month;
}
__decorate([
    IsInt(),
    Min(1990),
    Max(2099),
    __metadata("design:type", Number)
], YearMonth.prototype, "year", void 0);
__decorate([
    IsInt(),
    Min(1),
    Max(12),
    __metadata("design:type", Number)
], YearMonth.prototype, "month", void 0);
//# sourceMappingURL=generate-datev-export.dto.js.map